<a
  *ngIf="btnDetails.isRouterlink"
  [attr.target]="btnDetails.openInNewTab ? '_blank' : null"
  [routerLink]="btnDetails.href"
  [title]="btnDetails.title"
  (click)="trackEvent(btnDetails.title)"
  mat-button
>
  <top-nav-btn-inner
    [btnDetails]="btnDetails"
    [isBolded]="isBolded"
  ></top-nav-btn-inner>
</a>
<a
  *ngIf="!btnDetails.isRouterlink"
  [attr.target]="btnDetails.openInNewTab ? '_blank' : null"
  [attr.href]="
    btnDetails.href
      ? btnDetails.href
      : btnDetails.ninthGradeSuccessUrl
      ? btnDetails.ninthGradeSuccessUrl
      : null
  "
  [title]="btnDetails.title"
  (click)="clickBtn(btnDetails)"
  mat-button
  [ngClass]="{
    'no-padding-button': btnDetails.title && btnDetails.title.length > 10
  }"
>
  <top-nav-btn-inner
    [btnDetails]="btnDetails"
    [isBolded]="isBolded"
  ></top-nav-btn-inner>
</a>
